import { markdownToHtml } from "../shared/utils/markdownToHtml";

export async function insertText(text: string): Promise<void> {
  return new Promise((resolve, reject) => {
    try {
      const html = markdownToHtml(text);
      Office.context.mailbox.item?.body.prependAsync(
        html,
        { coercionType: Office.CoercionType.Html },
        (asyncResult: Office.AsyncResult<void>) => {
          if (asyncResult.status === Office.AsyncResultStatus.Failed) {
            reject(new Error(asyncResult.error.message));
          } else {
            resolve();
          }
        }
      );
    } catch (error) {
      console.error("Error inserting text:", error);
      reject(error);
    }
  });
}
